export default __webpack_public_path__ + "printful-logo.56323836.png";